<template>
  <FilterGroup v-model="show" :title="$t('servicesystem.common_objects.commonterms.lifecycle')"
    :applied-filters="[activeFilter]">
    <v-row no-gutters justify="start" align="center" class="pb-3">
      <p class="mr-3 mb-0">{{ $t("servicesystem.common_objects.commonterms.state") }}:</p>
      <DefaultActiveFilter :pk="pk" :default-to-active="defaultActive"></DefaultActiveFilter>
    </v-row>
  </FilterGroup>
</template>


<script>
import DefaultActiveFilter from "@/components/DefaultActiveFilter.vue";
import FilterGroup from "@/components/FilterGroup.vue";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";

export default {
  name: "DefaultLifeCycleFilterGroup",
  props: {
    pk: String,
    defaultHide: {
      type: Boolean,
      default: false,
    },
    defaultActive: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    FilterGroup,
    DefaultActiveFilter,
  },
  mixins: [FilterQueryMixin],

  data() {
    return {
      show: !this.defaultHide,
    };
  },

  methods: {},

  computed: {
    activeFilter: {
      get() {
        return this.getQueryParam("filter-active", 0);
      },
    },
  },

  watch: {},
};
</script>


<style lang="scss"></style>